import React from 'react';
import './WatchlistRow.css';

const WatchlistRow = React.memo(({ ticker, isActive, onClick }) => {
  const formatPrice = (price) => {
    if (!price) return '—';
    const num = parseFloat(price);
    return `$${num.toFixed(2)}`;
  };

  const formatDollarChange = (price, changePct) => {
    if (!price || !changePct) return '—';
    const priceNum = parseFloat(price);
    const changeNum = parseFloat(changePct);
    const dollarChange = priceNum * (changeNum / 100);
    const sign = dollarChange >= 0 ? '+' : '';
    return `${sign}${dollarChange.toFixed(2)}`;
  };

  const formatPercentChange = (change) => {
    if (change === null || change === undefined) return '—';
    const num = parseFloat(change);
    const sign = num >= 0 ? '+' : '';
    return `${sign}${num.toFixed(2)}%`;
  };

  const changeClass = parseFloat(ticker.change_pct) >= 0 ? 'positive' : 'negative';

  return (
    <div className={`watchlist-row ${isActive ? 'active' : ''}`} onClick={onClick}>
      <div className="watchlist-ticker">{ticker.ticker}</div>
      <div className="watchlist-last">{formatPrice(ticker.price)}</div>
      <div className={`watchlist-chg ${changeClass}`}>
        {formatDollarChange(ticker.price, ticker.change_pct)}
      </div>
      <div className={`watchlist-chg-pct ${changeClass}`}>
        {formatPercentChange(ticker.change_pct)}
      </div>
      <div className="watchlist-signals">
        {ticker.buy_count > 0 && (
          <div className="signal-dot dot-new-buy">{ticker.buy_count}</div>
        )}
        {ticker.hold_count > 0 && (
          <div className="signal-dot dot-long">{ticker.hold_count}</div>
        )}
        {ticker.sell_count > 0 && (
          <div className="signal-dot dot-new-sell">{ticker.sell_count}</div>
        )}
      </div>
    </div>
  );
});

export default WatchlistRow;
